import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { BadgeCheck, ShieldAlert } from "lucide-react";
import { ShareCertificate } from "@/components/ShareCertificate";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyPage() {
  const { code } = useParams();
  const [cert, setCert] = useState(undefined);
  useEffect(() => { axios.get(`${API}/certificates/${encodeURIComponent(code)}`).then(r => setCert(r.data)).catch(() => setCert(null)); }, [code]);
  return <section className="page-pad inner-page" data-testid="verify-page">
    <div className="page-intro compact"><div className="section-label"><span>01</span>CERTIFICATE VERIFICATION</div><h1>Credential <em>check.</em></h1></div>
    {cert && <img className="cert-preview" src={`${API}/certificates/${encodeURIComponent(cert.code)}/image.png`} alt={`Certificate for ${cert.name}`} data-testid="verify-certificate-image"/>}
    {cert === undefined ? <p className="admin-empty">Checking registry...</p> : cert ? <div className="verify-card" data-testid="verify-valid">
      <BadgeCheck size={30}/><div><h2>Valid certificate</h2><p><b data-testid="verify-name">{cert.name}</b> completed <b data-testid="verify-lesson">{cert.lesson_title}</b> on {new Date(cert.issued_at).toLocaleDateString()}.</p><code>{cert.code}</code><ShareCertificate code={cert.code}/></div>
    </div> : <div className="admin-denied" data-testid="verify-invalid"><ShieldAlert size={28}/><h2>Not found</h2><p>No certificate matches this code.</p></div>}
  </section>;
}
